import { render } from "./EggAnnouncement.vue?vue&type=template&id=5002979a"
import script from "./EggAnnouncement.vue?vue&type=script&lang=js"
export * from "./EggAnnouncement.vue?vue&type=script&lang=js"

import "./EggAnnouncement.vue?vue&type=style&index=0&id=5002979a&lang=css"
script.render = render

export default script